import React from 'react';
import "../Assests/Globalcss/Venture.css";
import { useLocation } from 'react-router-dom';
import "../Assests/Globalcss/NextSteps.css";
import Venturelogo from '../Assests/Globalimages/Venturelogo1.png';
import { useSearchParams } from 'react-router-dom';


const steps = [
    {
        title: 'Upload Information',
        description: 'Upload most recent payroll information which will be needed to calculate the Benefit Reserves',
        step: 'Step 1',
        icon: 'https://res.cloudinary.com/dzkcdotxx/image/upload/v1745496357/1_l4fyfm.png'
    },
    {
        title: 'Proposal Introduction',
        description: 'A proposal will be provided which will include Benefit Reserves and potential company savings',
        step: 'Step 2',
        icon: 'https://res.cloudinary.com/dzkcdotxx/image/upload/v1745496357/2_nfacww.png'
    },
    {
        title: 'Virtual Enrollment',
        description: 'Enrollment conducted virtually or on site employee training Post enrollment',
        step: 'Step 3',
        icon: 'https://res.cloudinary.com/dzkcdotxx/image/upload/v1745496357/3_j1sruk.png'
    },
    {
        title: 'Savings Start!',
        description: 'Clients start to see savings immediately in the first payroll run',
        step: 'Step 4',
        icon: 'https://res.cloudinary.com/dzkcdotxx/image/upload/v1744630771/Screenshot_from_2025-04-14_16-39-21_eqmqcv.png'
    },
];

function VentureRev() {
    const location = useLocation();
    const { company, employees, savings } = location.state || {};

    const [searchParams] = useSearchParams();

    const params = Object.fromEntries(searchParams.entries());
    
    // Or get specific parameters
    const companyName = searchParams.get('company');
    const employeesCount = searchParams.get('employees');
    const savingsCount = searchParams.get("savings")
  
    return (
        <div>
            <section className="venture-section">
                <div className="venture_container">
                    <div className="logo-image">
                        <img src="https://res.cloudinary.com/dzkcdotxx/image/upload/e_background_removal/v1745405554/WhatsApp_Image_2025-04-23_at_3.48.58_PM-removebg-preview_eufimt.png" alt="" />
                    </div>
                </div>
            </section>
            <section className="estimate-section">
                <div className="venture_container">
                    <div className="venture-text">
                        <h2>Estimated Annual Savings For:</h2>
                        <h2>{company || companyName || ''}</h2>
                        <h1>{savings || savingsCount || ''}</h1>
                        <ul>
                            <li>Aprox. {employees || employeesCount || ''} Employees</li>
                        </ul>
                    </div>
                </div>
            </section>
            <section className="program-section">
                <div className="venture_container">
                    <div className="main-program-text">
                        <div className="program-text">
                            <h4>How Does This Program Work?</h4>
                            <p>Capstone Health is a preventative health and wellness program
                                offered through a Section 125 pre-tax plan that <a href="">complements
                                    your existing benefits without replacing them.</a></p>
                            <p>Designed for employers with 10 or more full-time W-2
                                employees, Capstone takes a proactive approach to care,
                                helping to identify and manage health concerns before they
                                become costly insurance issues. At no net cost to employers or
                                employees, the program includes 24/7 virtual medical support,
                                prescription discounts, and access to many commonly used
                                medications.</p>
                            <p><a href="">Employers save an average of $600 per employee annually</a> in
                                FICA tax savings, while employees can increase their take-home
                                pay by $1,000 to $3,000 each year through pre-tax benefits.
                                These savings can also be used to purchase eligible medical
                                products. Supported by the Affordable Care Act, Capstone helps
                                create a healthier, more financially secure workforce, boosting
                                employee satisfaction and retention. All eligible employees are
                                automatically enrolled, and Capstone takes care of all the setup
                                and administration.
                            </p>
                            <h4>Benifits For Your Business</h4>
                            <h3>FICA Tax Savings -</h3>
                            <p>Employers save an average of $600 per employee annually in FICA tax
                                savings. A business with 100 employees could save approximately
                                $60,000 per year.
                            </p>
                            <h3>Increased Take-Home Pay For Employees -</h3>
                            <p>Employees can increase their annual take-home pay by $1000 to $3000.
                                This tax-efficient structure boosts employee income, improving financial
                                well being.</p>
                            <h3>Improved Employee Retention -</h3>
                            <p>Enhanced take-home pay and comprehensive wellness benefits boost
                                employee satisfaction and retention. Demonstrates the employers
                                commitment to the employees well-being.</p>
                        </div>
                        <div className="benefits-text">
                            <h4>Program Benefits</h4>
                            <ul>
                                <li>Primary Care</li>
                                <li>Urgent Care</li>
                                <li>Unlimited Virtual Health Benifits
                                </li>
                                <li>Behavioral Health</li>
                                <li>Chronic Disease Managment</li>
                            </ul>
                            <div className="HighLights">
                                <h4>Program HighLights</h4>
                            </div>
                            <ul>
                                <li>Proactive Health Management</li>
                                <li> <img className="start-image" src="https://res.cloudinary.com/dzkcdotxx/image/upload/e_background_removal/v1745402294/Screenshot_from_2025-04-23_14-57-59_cxvff5.png" alt="" />Average of $600 Savings Per Employee/Year</li>
                                <ul className="employ-li">
                                    <li>Savings Realized By The Employer</li>
                                </ul>
                                <li> <img className="start-image" src="https://res.cloudinary.com/dzkcdotxx/image/upload/e_background_removal/v1745402294/Screenshot_from_2025-04-23_14-57-59_cxvff5.png" alt="" />Average of $100 Savings Per Employee/Month</li>
                                <ul className="employ-li">
                                    <li>Savings Realized By The Employer</li>
                                </ul>
                                <li>Triple Imdemnity Guarantee</li>
                                <li>ZERO Net Cost</li>
                            </ul>
                        </div>
                    </div>
                </div>
            <div className="footer-bar"></div>
            </section>


            <div className="next-steps-container">
                <div className="top-bar">
                    <img src={Venturelogo} alt="VentureRev Logo" className="Venture-logo" />
                </div>
                <div className="content-wrapper">
                    <h1 className="next-title">Next Steps....</h1>
                    <div className="steps-grid">
                        {steps.map((step, index) => (
                            <div className="step-row" key={index}>
                                <div className="circle-check">
                                    <div className="circle">
                                        <span className="checkmark">✓</span>
                                    </div>
                                    {/* {index !== steps.length - 1 && <div className="vertical-line"></div>} */}
                                </div>
                                <div className="step-content">
                                    <div className="step-icon-box">
                                        <img
                                            src={step.icon}
                                            alt="Step Icon"
                                            style={{ display: 'block' }}
                                        />
                                    </div>
                                    <div className="step-info">
                                        {/* <div className="step-number">{step.step}</div> */}
                                        <h3 className="step-title">{step.title}</h3>
                                        <li className="step-description">{step.description}</li>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <a href='https://calendly.com/billweltriohealth/30min' target='_blank' className="meeting-button">
                        <button>Schedule a meeting</button>
                    </a>
                </div>
                <div className="footer-bar"></div>
            </div>

        </div>
    )
}

export default VentureRev;